import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BookOpen, ChevronLeft } from "lucide-react";
import { api } from "@/lib/api";
import { AffiliateDisclosure } from "@/components/AffiliateDisclosure";
import { Seo } from "@/lib/seo";

export default function ShopAffiliatesGuides() {
  const [guides, setGuides] = useState([]);
  const [active, setActive] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/shop-affiliates/guides")
      .then((r) => setGuides(r.data))
      .catch(() => setGuides([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="affiliate-guides-page">
      <Seo title="Buying Guides" path="/gateway/guides" description="Johnny's honest buying guides — practical advice on choosing the right product before you shop." />
      <section className="bg-navy">
        <div className="jm-container py-14">
          <Link to="/shop-affiliates" className="inline-flex items-center gap-1 text-cream/70 hover:text-gold text-sm font-bold">
            <ChevronLeft className="w-4 h-4" /> Back to Shop Affiliates
          </Link>
          <h1 className="mt-4 font-display text-4xl sm:text-5xl text-cream">Buying Guides</h1>
          <p className="mt-3 text-cream/75 max-w-2xl">Johnny's honest advice on choosing the right product.</p>
        </div>
      </section>

      <div className="jm-container py-10">
        <AffiliateDisclosure />

        {loading ? (
          <p className="mt-12 text-center text-navy/50">Loading guides...</p>
        ) : guides.length === 0 ? (
          <div data-testid="guides-empty" className="mt-12 text-center bg-white rounded-xl border border-navy/15 p-12">
            <BookOpen className="w-12 h-12 text-navy/20 mx-auto" />
            <p className="font-display text-2xl text-navy mt-4">Guides coming soon</p>
            <p className="text-ink/60 mt-2">Johnny is writing up his best buying tips. Check back shortly.</p>
          </div>
        ) : active ? (
          <article data-testid="guide-detail" className="mt-8 max-w-3xl bg-white rounded-xl border border-navy/15 p-8">
            <button onClick={() => setActive(null)} className="inline-flex items-center gap-1 text-brick font-bold text-sm">
              <ChevronLeft className="w-4 h-4" /> All guides
            </button>
            <h2 className="mt-4 font-display text-3xl text-navy">{active.title}</h2>
            <div className="mt-4 text-ink/80 leading-relaxed whitespace-pre-line">{active.body}</div>
          </article>
        ) : (
          <div className="mt-8 grid gap-5 sm:grid-cols-2">
            {guides.map((g) => (
              <button
                key={g.id}
                data-testid={`guide-card-${g.id}`}
                onClick={() => setActive(g)}
                className="text-left bg-white rounded-xl border border-navy/15 p-6 hover:border-brick transition-colors"
              >
                <BookOpen className="w-6 h-6 text-gold" />
                <h3 className="mt-3 font-display text-xl text-navy">{g.title}</h3>
                {g.summary && <p className="mt-2 text-sm text-ink/70">{g.summary}</p>}
                <span className="mt-3 inline-block text-xs font-bold text-brick uppercase">Read guide →</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
